import ConsultantAssign from './ScanCheck';

export default ConsultantAssign;
